var styles = {"link":"MarketplaceHeader-module_link__2_Kmi","logo":"MarketplaceHeader-module_logo__1OoWN","headerContainer":"MarketplaceHeader-module_headerContainer__3ObVc"};

export { styles as default };
//# sourceMappingURL=MarketplaceHeader.module.css.js.map
